import { render } from "./Spinners.vue?vue&type=template&id=76742a91&scoped=true"
const script = {}

import "./Spinners.vue?vue&type=style&index=0&id=76742a91&scoped=true&lang=css"

import exportComponent from "/hpgdata/workspace/kumc_hospital_front_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76742a91"]])

export default __exports__